import { html, repeat, ref, when } from '@genesislcap/web-core';
import {SyndicateInfo, SyndicateRole} from './syndicate-info';
import { getClassesForSyndicateMemberName } from './syndicate-utils';

export const syndicateInfoTemplate = html<SyndicateInfo>`
  <div class="syndicate-info-container">
    <span 
      class="syndicate-info-link"
      @click="${(x) => x.toggleTooltip()}">
      Syndicate Info
    </span>
    
    ${when(
      (x) => x.showTooltip,
      html<SyndicateInfo>`
        <div class="syndicate-tooltip" ${ref('syndicateTooltip')}>
          <div class="syndicate-tooltip-header">
            <span>Syndicate Info</span>
            <rapid-button class="close-icon" aria-label="close" appearance="stealth" @click="${(x) => x.closeSyndicateTooltip()}">
              <rapid-icon name="times" size="lg"></rapid-icon>
            </rapid-button>
          </div>
          <div class="syndicate-tooltip-body">
            ${when(
              (x) => x.syndicateRoles.length > 0 && x.syndicateRoles.some(role => role.members.length > 0 && role.members[0] !== ''),
              html<SyndicateInfo>`
                ${repeat(
                  (x) => x.syndicateRoles,
                  html<SyndicateRole>`
                    <div class="syndicate-row">
                      <div class="syndicate-role">${(r) => r.role}</div>
                      <div class="syndicate-members">
                        ${repeat(
                          (r) => r.members,
                          html<string>`
                            <div class="syndicate-member-name ${(m, ctx) => getClassesForSyndicateMemberName(ctx.parent.role, m).join(' ')}">${(m) => m}</div>
                          `,
                        )}
                      </div>
                    </div>
                  `,
                )}
              `,
              html<SyndicateInfo>`
                <div class="no-syndicate-data">
                  Syndicate Information not available.
                </div>
              `
            )}
          </div>
        </div>
      `
    )}
  </div>
`; 
